import { gql } from "@apollo/client";

export const userIdQuery = gql`
  query {
    user {
      id
    }
  }
`;
